import postList from './postList';
import getList from './getList';

import Axios from 'axios';
//const qs = require('qs');
import qs from  'qs';
let http = {};
let get = {};
// console.log(process.env.VUE_APP_PAYLOCATION);
// console.log('*********',process.env.VUE_APP_URL);
Axios.defaults.baseURL = process.env.VUE_APP_URL;
Axios.defaults.headers.common.Accept = 'application/json';

Axios.interceptors.request.use(config => {
  // console.log(`请求数据=`, config.data);
  //默认所有接口loading
  // if (!config.params) {
  //     config.params = {};
  // }
  // if(config.url.indexOf('randpage')>0){
  //     console.time('loading')
  // }
  if(config.url.includes('policyInfoCar') || config.url.includes('carPolicyEndor') || config.url.includes('policyInfoDetails')){
    Axios.defaults.baseURL = process.env.VUE_APP_NOCAR_URL;
    config.baseURL = process.env.VUE_APP_NOCAR_URL;
  }else if(config.url.includes('endorByLicenseNo') || config.url.includes('endorByLicenseNoApprover')||config.url.includes('endorIdentCode')){
    Axios.defaults.baseURL = process.env.VUE_APP_UAT_URL;
    config.baseURL = process.env.VUE_APP_UAT_URL;
  }else{
    Axios.defaults.baseURL = process.env.VUE_APP_URL;
    config.baseURL = process.env.VUE_APP_URL;
  }
  if (config.headers["Content-Type"]&&config.headers["Content-Type"].indexOf('application/x-www-form-urlencoded')>-1) {
      config.data = qs.stringify(config.data);
  }
  // if(config.baseURL.indexOf('eauto/official') > -1  && sessionStorage.getItem('flowId')){
  //   config.headers['x-carinsure-flowid'] = window.sessionStorage.getItem('flowId') || '';
  // }
  if(config.baseURL.indexOf('sinosafe.com.cn/official') > -1  && sessionStorage.getItem('flowId')){
    config.headers['x-carinsure-flowid'] = window.sessionStorage.getItem('flowId') || '';
  }
  // console.log('请求前配置-config', config);
  return config;
}, err => {
  // Toast

  return Promise.reject(err);
})

Axios.interceptors.response.use(
  (response) => {
    if (response.headers['x-eshopauto-token']) {
      const token = response.headers['x-eshopauto-token'];
      Axios.defaults.headers.common['x-eshopauto-token'] = token;
      localStorage.setItem('x-eshopauto-token', token);
    }
    if(response.config.url.indexOf('/quoteInit')>-1){
      Axios.defaults.headers.common['x-carinsure-flowid'] =  response.data.result ;
      sessionStorage.setItem('flowId', response.data.result);
    }
    if (['E10002', 'E10007', 'E10008'].indexOf(response.data.resultCode) >= 0) {
      return Promise.reject('请重新登录');
    }
    return response;
  },
  (error) => {
    if ([404, 403].indexOf(error.response.status) >= 0) {
      return Promise.reject('网络异常，请刷新重试');
    }
    if (error.response.status === 401) {
      return Promise.reject('请重新登录');
    }
    return Promise.reject('系统繁忙，请稍后再试');
  });


postList.forEach(item => {
  // console.log(process.env.VUE_APP_NOCAR_URL)
  // console.log(process.env.VUE_APP_UAT_URL)
  http[item.name] = (opt) => {
    let options = {
      showLoading: true,
      closeLoading: true,
    };
    opt = opt || {};
    options =Object.assign({},options,opt);
    if(options.showLoading){
      Loading.show(options.loadingText);
    }

    let newUrl = item.url;
    if(options.params){
      let params = options.params.join('/');
      newUrl = item.url + `/${params}`;
    }

    if(options.query){
      let _query = [];
      Object.keys(options.query).forEach(key=>{
        _query.push(`${key}=${options.query[key]}`);
      })
      let query = _query.join("&")
      //debugger
      newUrl = item.url + `?${query}`;
    }
    return Axios.post(newUrl, options.data, item.config)
        .then(res => {
          if(options.closeLoading){
            Loading.hide();
          }
          return (res.data || {});
        })
        .catch( error => {
          if(options.closeLoading){
            Loading.hide();
          }
          return Promise.reject(error);
      });
  };
});


getList.forEach(item => {
  if(item.name==='endorIdentCode'){
    Axios.defaults.baseURL = process.env.VUE_APP_UAT_URL;
  }
  get[item.name] = opt => {
    /* options = options || {};
    options.showLoading = options.showLoading || true;
    options.closeLoading = options.closeLoading || true; */
    let options = {
      showLoading: true,
      closeLoading: true,
    };
    opt = opt || {};
    options =Object.assign({},options,opt);

    if(options.showLoading){
      Loading.show(options.loadingText);
    }

    let newUrl = item.url;
    if(options.params){
      let params = options.params.join('/');
      newUrl = item.url + `/${params}`;
    }

    if(options.query){
      let _query = [];
      Object.keys(options.query).forEach(key=>{
        _query.push(`${key}=${options.query[key]}`);
      })
      let query = _query.join("&")
      newUrl = item.url + `?${query}`;
    }
    
    return Axios.get(newUrl)
        .then(res => {
          if(options.closeLoading){
            Loading.hide();
          }
          return (res.data || {});
        })
        .catch(error => {
          if(options.closeLoading){
            Loading.hide();
          }
          return Promise.reject(error);
      });
  }
});

export {
  http,
  get
};